import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { PaymentTerm } from '@cemex-core/cmx-api';
import { PaymentTermsResponse } from '@ordersnproducts/modules/order-builder/modules/rms-specification/models/payment-term.op.model';
import * as fromPaymentTermsActions from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/payment-terms.op.actions';
import * as fromProductsActions from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/products.op.actions';

export interface State extends EntityState<PaymentTerm> {
  selectedPaymentTermCode: string | null;
  loading: boolean;
}

export const adapter: EntityAdapter<PaymentTerm> = createEntityAdapter<PaymentTerm>({
  selectId: (_paymentTerm: PaymentTerm) => _paymentTerm.paymentTermCode,
  sortComparer: false,
});

export const initialState: State = adapter.getInitialState({
  selectedPaymentTermCode: null,
  loading: false,
});

export function reducer(state = initialState, action: fromPaymentTermsActions.Actions): State {
  switch (action.type) {
    case fromPaymentTermsActions.ActionTypes.ADD: {
      return adapter.addOne((action as fromPaymentTermsActions.Add).payload, state);
    }
    case fromProductsActions.ActionTypes.RESET: {
      return adapter.removeAll(state);
    }
    case fromPaymentTermsActions.ActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      };
    }
    case fromPaymentTermsActions.ActionTypes.LOAD_SUCCESS: {
      const paymentTerms: PaymentTermsResponse = action.payload;
      return adapter.addMany(paymentTerms.paymentTerms, { ...state, loading: false });
    }
    case fromPaymentTermsActions.ActionTypes.LOAD_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
}
